import common from '../../../common/common';
export default {
    namespaced: true,
    state: {
        lf_tag: {
            script: false // LF画面でのLFタグ出力有無
        },
        ga_tag: {
            script: false // LF画面でのGA計測タグ出力有無
        },
        mail_delivery: {
            switch: false // メール配信機能使用有無
        },
        recaptcha: {
            switch: false, // reCAPCTHA使用有無
            key: '' // reCAPTCHAのKEY
        },
        user_domain: '',    //user画面のドメイン
        support_domain: '', //support画面のドメイン
        lftag_custom: [] //lftagのカスタム変数を返却
    },
    mutations: {
        // config基本情報をセット
        setConfigInformation(state, config_information) {
            if (config_information.hasOwnProperty('lf_tag')) {
                state.lf_tag.script = config_information.lf_tag.hasOwnProperty('script')
                    ? config_information.lf_tag.script
                    : false;
            }
            if (config_information.hasOwnProperty('ga_tag')) {
                state.ga_tag.script = config_information.ga_tag.hasOwnProperty('script')
                    ? config_information.ga_tag.script
                    : false;
            }
            if (config_information.hasOwnProperty('mail_delivery')) {
                state.mail_delivery.switch = config_information.mail_delivery.hasOwnProperty('switch')
                    ? config_information.mail_delivery.switch
                    : false;
            }
            if (config_information.hasOwnProperty('recaptcha')) {
                state.recaptcha.switch = config_information.recaptcha.hasOwnProperty('switch')
                    ? config_information.recaptcha.switch
                    : false;
                state.recaptcha.key = config_information.recaptcha.hasOwnProperty('key')
                    ? config_information.recaptcha.key
                    : '';
            }
            if (config_information.hasOwnProperty('user_domain')) {
                state.user_domain = config_information.user_domain
            }
            if (config_information.hasOwnProperty('support_domain')) {
                state.support_domain = config_information.support_domain
            }
            if (config_information.hasOwnProperty('lftag_custom')) {
                state.lftag_custom = config_information.lftag_custom
            }
        }
    },
    actions: {},
    getters: {
        // LF画面でのLFタグ出力有無を取得
        enableLfTagScript(state) {
            return state.lf_tag.script;
        },
        // LF画面でのGA計測タグ出力有無を取得
        enableGaTagScript(state) {
            return state.ga_tag.script;
        },
        // メール配信機能使用有無を取得
        enableMailDeliverySwitch(state) {
            return state.mail_delivery.switch;
        },
        // reCAPTCHA使用有無を取得
        enableRecaptchaSwitch(state) {
            return state.recaptcha.switch;
        },
        // reCAPTCHAのKEYを取得
        getRecaptchaKey(state) {
            return state.recaptcha.key;
        },
        // user画面のドメインを取得
        getUserDomain(state, getters, rootState, rootGetters) {
            if (common.isDomainSupport()) {
                return getters.getSupportDomain;
            }
            return state.user_domain;
        },
        // support画面のドメインを取得
        getSupportDomain(state) {
            return state.support_domain;
        },
        // lftagのカスタム変数を取得
        getLftagCustom(state){
            return state.lftag_custom;
        }
    }
};
